import React, { useContext, useEffect } from "react";
import { UserAuthenticationContext } from "../../../Context/UserAuthenticationContext";
import { SetTitle } from "../../../Helpers/PageMetadata";
import ArticlesGrid from "../../../Components/Layouts/Content/Read/ArticlesGrid";
import ArticleTopics from "../../../Components/Layouts/Content/Read/ArticleTopics";
import useFetchArticleFeed from "../../../Hooks/Content/Read/useFetchArticleFeed";

export default function ArticlesFeed() {
    const { doesAuthTokenExist } = useContext(UserAuthenticationContext);
    const { categories, featuredArticle, featuredIsStaffPick, articleGroups, loading, error, retry } = useFetchArticleFeed();

    useEffect(() => { SetTitle("Articles"); }, []);

    return <div className="page page--read">
        <header className="article-feed__header">
            <h1>Articles</h1>
            <p>Fresh perspectives, independent voices and stories worth exploring.</p>
        </header>
        <ArticleTopics categories={categories}/>
        {error && <div className="article-feed__notice" role="alert">
            <p>{error}</p><button type="button" onClick={retry} disabled={loading}>Try again</button>
        </div>}
        <ArticlesGrid mode="editorial" featuredArticle={featuredArticle} featuredIsStaffPick={featuredIsStaffPick} articleGroups={articleGroups}
            disableLoadMore isLoading={loading} doesAuthTokenExist={doesAuthTokenExist()}
            emptyMessage="There are no published articles yet. Please check back soon."/>
    </div>;
}